import NotFound from '@/components/workspace/shared/not-found'

export function SharedWithMePage() {
  return (
    <NotFound
      title="No projects"
      description="Create a new project to get started"
      buttonText="Create New Project"
      buttonLink="/canvas"
    />
  )
}
